module.exports = __webpack_public_path__ + "img/padlock.4dcbcc5b.svg";